import { getAction, postAction } from '@/api/manage';
import { checkOnlyUser } from '@/api/api';
export default {
  name: "Step1",
  data: function data() {
    return {
      form: this.$form.createForm(this),
      inputCodeContent: "",
      inputCodeNull: true,
      verifiedCode: "",
      validatorRules: {
        username: {
          rules: [{
            required: false
          }, {
            validator: this.validateInputUsername
          }]
        },
        inputCode: {
          rules: [{
            required: true,
            message: '请输入验证码!'
          }]
        }
      },
      randCodeImage: '',
      requestCodeSuccess: true,
      currdatetime: ''
    };
  },
  created: function created() {
    this.handleChangeCheckCode();
  },
  methods: {
    handleChangeCheckCode: function handleChangeCheckCode() {
      var _this = this;
      this.currdatetime = new Date().getTime();
      getAction("/sys/randomImage/number/".concat(this.currdatetime)).then(function (res) {
        if (res.success) {
          _this.randCodeImage = res.result;
          _this.requestCodeSuccess = true;
        } else {
          _this.$message.error(res.message);
          _this.requestCodeSuccess = false;
        }
      }).catch(function () {
        _this.requestCodeSuccess = false;
      });
    },
    nextStep: function nextStep() {
      var that = this;
      this.form.validateFields(function (err, values) {
        if (!err) {
          var isPhone = false;
          var params = {};
          var reg = /^[1-9]\d*$|^0$/;
          var username = values.username;
          if (reg.test(username) == true) {
            params.phone = username;
            isPhone = true;
          } else {
            params.username = username;
          }
          that.validateInputCode().then(function () {
            getAction("/sys/user/querySysUser", params).then(function (res) {
              if (res.success) {
                var userList = {
                  username: res.result.username,
                  phone: res.result.phone,
                  isPhone: isPhone
                };
                setTimeout(function () {
                  that.$emit('nextStep', userList);
                });
              }
            });
          });
        }
      });
    },
    validateInputCode: function validateInputCode() {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        postAction("/sys/checkCaptcha", {
          captcha: _this2.inputCodeContent,
          checkKey: _this2.currdatetime
        }).then(function (res) {
          if (res.success) {
            resolve();
          } else {
            _this2.$message.error(res.message);
            reject();
          }
        });
      });
    },
    inputCodeChange: function inputCodeChange(e) {
      this.inputCodeContent = e.target.value;
      console.log(this.inputCodeContent);
      if (!e.target.value || 0 == e.target.value) {
        this.inputCodeNull = true;
      } else {
        this.inputCodeContent = this.inputCodeContent.toLowerCase();
        this.inputCodeNull = false;
      }
    },
    generateCode: function generateCode(value) {
      this.verifiedCode = value.toLowerCase();
      console.log(this.verifiedCode);
    },
    validateInputUsername: function validateInputUsername(rule, value, callback) {
      console.log(value);
      var reg = /^[0-9]+.?[0-9]*/;
      if (!value) {
        callback("请输入用户名和手机号！");
      }

      //判断用户输入账号还是手机号码
      if (reg.test(value)) {
        var params = {
          phone: value
        };
        checkOnlyUser(params).then(function (res) {
          if (res.success) {
            callback("用户名不存在!");
          } else {
            callback();
          }
        });
      } else {
        var params = {
          username: value
        };
        checkOnlyUser(params).then(function (res) {
          if (res.success) {
            callback("用户名不存在!");
          } else {
            callback();
          }
        });
      }
    }
  }
};